import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {filterWebsiteUser_template} from "./filterWebsiteUser_template";
import {filterTag_template} from "./filterTag_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";

declare var ko: any;

export class modList_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;
    protected userFilter: filterWebsiteUser_template;
    protected tagFilter: filterTag_template;
    protected statusFilter: multipleSelector_template;
    protected moderationStatusFilter: multipleSelector_template;
    protected adultOnlyFilter: multipleSelector_template;

    protected getTemplateHtml(): string {

        return `

            <div class="sub-header w-justify">
                <div class="w-left">
                    <span id="mod-status-filter" class="mod-status-filter">
                    ` + this.statusFilter.getHtmlBuild() + `
                    </span>
                    <span style="margin-left: 3rem">
                    ` + this.moderationStatusFilter.getHtmlBuild() + `
                    </span>
                    <span id="mod-adult-only-filter" style="margin-left: 3rem" class="mod-adult-only-filter">
                    ` + this.adultOnlyFilter.getHtmlBuild() + `
                    </span>
                    <div style="margin-left: 3rem">
                    ` + this.tagFilter.getHtmlBuild() + `
                    </div>
                    <div style="margin-left: 1rem">
                    ` + this.userFilter.getHtmlBuild() + `
                    </div>
                </div>
            </div>

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-users"></div>
                    <div id="selected-tags"></div>
                    <div id="selected-status"></div>
                    <div id="selected-moderation-status"></div>
                    <div id="selected-adult-only"></div>
                </div>
            </div>

            <div class="list-header w-justify" >

                <div class="w-left" data-bind="if: isAddButtonShown">
                    <button data-bind="click: onClickAdd" class="btn secondary icon i-add" type="button">Create Mod</button>
                </div>

                <div class="w-center">
                        ` + this.filter.getHtmlBuild() + `
                </div>

                <div class="w-right">
                    ` + this.pagination.getHtmlBuild() + `
                </div>
            </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'title') }, css: { 'list-sort-desc': orderByAndDirection()=='title_DESC', 'list-sort-asc': orderByAndDirection()=='title_ASC' }">Title</span></th>
                            <th><span></span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'idAccessPointUser') }, css: { 'list-sort-desc': orderByAndDirection()=='idAccessPointUser_DESC', 'list-sort-asc': orderByAndDirection()=='idAccessPointUser_ASC' }">Modder</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'idTag') }, css: { 'list-sort-desc': orderByAndDirection()=='idTag_DESC', 'list-sort-asc': orderByAndDirection()=='idTag_ASC' }">Tag Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'idStatus') }, css: { 'list-sort-desc': orderByAndDirection()=='idStatus_DESC', 'list-sort-asc': orderByAndDirection()=='idStatus_ASC' }">Status</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'idModerationStatus') }, css: { 'list-sort-desc': orderByAndDirection()=='idModerationStatus_DESC', 'list-sort-asc': orderByAndDirection()=='idModerationStatus_ASC' }">Moderation Status</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'isAdultOnly') }, css: { 'list-sort-desc': orderByAndDirection()=='isAdultOnly_DESC', 'list-sort-asc': orderByAndDirection()=='isAdultOnly_ASC' }">Adult-only</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'created') }, css: { 'list-sort-desc': orderByAndDirection()=='created_DESC', 'list-sort-asc': orderByAndDirection()=='created_ASC' }">Date Created</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'updated') }, css: { 'list-sort-desc': orderByAndDirection()=='updated_DESC', 'list-sort-asc': orderByAndDirection()=='updated_ASC' }">Date Updated</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: mods">
                        <tr class="cursor">
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click"><span data-bind="text: id"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click"><span data-bind="text: title"></span></a></td>
                            <td><a class="btn icon border only-icon i-link" data-bind="event: { click: $parent.onClickViewOnSite }, attr: { id : 'site-view' + $data.id }"></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click"><span data-bind="text: modderInfo?.displayName || modderInfo?.fullName || ''"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click"><span data-bind="text: tag && tag.name ? tag.name : ''"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click"><span data-bind="text: status && status.name ? status.name : ''"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click"><span data-bind="text: moderationStatus && moderationStatus.name ? moderationStatus.name : ''"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click"><span data-bind="text: (isAdultOnly == 1 || isAdultOnly === true) ? 'Yes' : 'No'"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click"><span data-bind="text: created"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click"><span data-bind="text: updated"></span></a></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            `;
    }

    protected initPartial(): void {

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller)

        this.userFilter = new filterWebsiteUser_template("userFilter", this.getTemplateViewModel(), this.caller);
        this.userFilter.asMultipleSelectionMode();
        this.userFilter.setTagContainerId('selected-users');
        this.userFilter.setTagContainerCaption('Selected users:');
        this.userFilter.setPlaceholderText("User");
        this.userFilter.setUniqueIdentifier("userId");

        this.tagFilter = new filterTag_template("tagFilter", this.getTemplateViewModel(), this.caller);
        this.tagFilter.asMultipleSelectionMode();

        this.statusFilter = new multipleSelector_template("statusFilter", this.getTemplateViewModel(), this.caller);
        this.statusFilter.setLabel("Status");
        this.statusFilter.setFilterContainerClass('margin-neg');
        this.statusFilter.setTagContainerId('selected-status');
        this.statusFilter.setTagContainerCaption('Selected Status:');

        this.moderationStatusFilter = new multipleSelector_template("moderationStatusFilter", this.getTemplateViewModel(), this.caller);
        this.moderationStatusFilter.setLabel("Moderation Status");
        this.moderationStatusFilter.setFilterContainerClass('margin-neg');
        this.moderationStatusFilter.setTagContainerId('selected-moderation-status');
        this.moderationStatusFilter.setTagContainerCaption('Selected Moderation Status:');

        this.adultOnlyFilter = new multipleSelector_template("adultOnlyFilter", this.getTemplateViewModel(), this.caller);
        this.adultOnlyFilter.setLabel("Adult-only");
        this.adultOnlyFilter.setFilterContainerClass('margin-neg');
        this.adultOnlyFilter.setTagContainerId('selected-adult-only');
        this.adultOnlyFilter.setTagContainerCaption('Selected Adult-only:');
        this.adultOnlyFilter.setItems([{ id: 1, name: 'Yes' }, { id: 0, name: 'No' }]);
        this.adultOnlyFilter.setSearchEnabled(false);
    }

    protected getTemplateName(): string {
        return "modList-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
            orderBy: ko.observable("created")
            , orderByDirection: ko.observable("DESC")
            , mods: ko.observableArray([])
            , orderByAndDirection: ko.observable("created_DESC")
            , isAddButtonShown: ko.observable(true)
            , onClickReorder: function (value, data, event) {
                huit_neuf_this.onClickReorder(value, data, event);
            }
            , onClickAdd: function () {
                huit_neuf_this.onClickAdd();
            }
            , onClickView: function (data) {
                huit_neuf_this.onClickView(data);
            }
            , onClickViewOnSite: function (data) {
                huit_neuf_this.onClickViewOnSite(data);
            }
        };
    }

    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {

        return {
            orderBy: this.getTemplateViewModel().orderBy
            , orderByDirection: this.getTemplateViewModel().orderByDirection
            , orderByAndDirection: this.getTemplateViewModel().orderByAndDirection
            , pagination: this.getTemplateViewModel().pagination
            ,filters : {
                keywords : this.getTemplateViewModel().filter.filterKeyword
                ,accessPointUsers: this.userFilter.getUsersForRequest()
                ,tags: this.tagFilter.getTagsForRequest(),
                statusIds: this.statusFilter.getSelectedItems(),
                moderationStatusIds: this.moderationStatusFilter.getSelectedItems(),
                isAdultOnlyIds: this.adultOnlyFilter.getSelectedItems(),
            },
        }
    }


    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.listReorder();
    }

    public setViewModelFromRequest(urlParams){

        if (urlParams == null){
            return;
        }

        if(urlParams.accessPointUsers){
            this.userFilter.setSelectedUsersFromRequestParams(urlParams.accessPointUsers);
        }

        if(urlParams.tags){
            this.tagFilter.setSelectedTagsFromRequestParams(urlParams.tags);
        }
        if(urlParams.statusIds){
            this.setFilterSelectedItems(this.statusFilter, urlParams.statusIds);
        }
        if(urlParams.moderationStatusIds){
            this.setFilterSelectedItems(this.moderationStatusFilter, urlParams.moderationStatusIds);
        }
        if (urlParams.isAdultOnlyIds) {
            this.setFilterSelectedItems(this.adultOnlyFilter, urlParams.isAdultOnlyIds);
        } else if (urlParams.isAdultOnly === 0 || urlParams.isAdultOnly === '0' || urlParams.isAdultOnly === 1 || urlParams.isAdultOnly === '1') {
            this.setFilterSelectedItems(this.adultOnlyFilter, urlParams.isAdultOnly);
        } else {
            this.setFilterSelectedItems(this.adultOnlyFilter, null);
        }

        let keywordString = urlParams.keywords
        if(urlParams.keywords){
            keywordString = urlParams.keywords.replaceAll("+", " ");
        }

        this.filter.getTemplateViewModel().filterKeyword(keywordString);
    }

    public setFilterSelectedItems(objFilter, urlParams){

        let splitString = [];

        // Multi select filters.
        if(urlParams){
            if(typeof urlParams == "string"){
                splitString = urlParams.split(",");
            }else if(Array.isArray(urlParams)){
                splitString = urlParams;
            }else{
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {
                if(!isNaN(Number(id))){
                    id = Number(id);
                }else{
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        }else{
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    public onClickAdd() {

        this.caller.add();
    }

    public setMods(data) {

        this.getTemplateViewModel().mods(data);
    }

    public onClickView(data){

        this.caller.view(data.id);
    }

    public onClickViewOnSite(data) {

        this.caller.viewOnSite(data);
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    //new
    protected setTagFilter(tags) {

        this.getTemplateViewModel().tagFilter.tags(tags);
    }

    public setStatus(items) {

        this.statusFilter.setItems(items);
    }

    public setModerationStatus(items) {

        this.moderationStatusFilter.setItems(items);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/modList_template.ts